import { CASES_LIST_TAG, LIST_QUERY_CACHE_TTL_SECONDS } from '@/api/constants';
import { api } from '@/api/core';

export interface GetHistoryRowDetailsRequest {
  matterId: string;
  historyRowId: string;
}

export interface GetHistoryRowDetailsResponse {
  /** Free-text description of the history row — the same text `/matter/history` returns as `details`. */
  details: string;
}

export function buildGetHistoryRowDetailsQueryConfig({ matterId, historyRowId }: GetHistoryRowDetailsRequest) {
  return {
    url: '/matter/history-row-details',
    method: 'GET' as const,
    params: { matter_id: matterId, history_row_id: historyRowId },
  };
}

/** Details of one matter history row. Used by chat citations that point at a row with no document. */
const getHistoryRowDetailsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHistoryRowDetails: builder.query<GetHistoryRowDetailsResponse, GetHistoryRowDetailsRequest>({
      query: (args) => buildGetHistoryRowDetailsQueryConfig(args),
      providesTags: (_result, _error, { matterId, historyRowId }) => [
        { type: CASES_LIST_TAG, id: `history-row-details-${matterId}-${historyRowId}` },
      ],
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetHistoryRowDetailsQuery } = getHistoryRowDetailsApi;
